import actionSubOrderItem from '../../../../../Services/actionSubOrder'

export default (guid, action) => (dispatch) => {

  dispatch(actionSubOrderItem(guid, action))

}
